import { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import throttle from "lodash.throttle";

import P2BreadcrumbItem from "./P2BreadcrumbItem";
import { LeftArrow, RightArrow } from "../../resources/svg_components";

// This component takes:
// 1. a "pages" array where each page is an object with a "title" and a "link" property.
// 2. a "navigate" function which is the return value of useNavigate.
// If the link is not provided for a particular page, this component will use the navigate function.
// An error will occur if both link and navigate are not provided.
function P2Breadcrumb({ pages, navigate, style }) {
  const length = pages.length;
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener(
      "resize",
      throttle(() => setWidth(window.innerWidth), 200)
    );
  }, []);

  // Only 1 page
  if (length === 1) {
    const prevPage = pages[0];
    return (
      <div className="polymer-breadcrumb__container" style={style}>
        <LeftArrow strokeColor="#085054"/>
        {prevPage.link ? (
          <div onClick={() => {
            if(prevPage?.action){
              prevPage.action();
            }else{
              window.location.href = prevPage.link;
            }
          }} className="polymer-breadcrumb__title polymer-breadcrumb__title-green">
            {prevPage.title}
          </div>
        ) : (
          <button
            className="polymer-breadcrumb__title polymer-breadcrumb__title-green"
            onClick={() => {
              navigate(-1);
            }}
          >
            {prevPage.title}
          </button>
        )}
      </div>
    );

    // Mobile view
  } else if (width <= 768) {
    const prevPage = pages[length - 2];
    return (
      <div className="polymer-breadcrumb__container" style={style}>
        <LeftArrow strokeColor="#085054"/>
        {prevPage.link ? (
          <div onClick={() => {
            if(prevPage?.action){
              prevPage.action();
            }else{
              window.location.href = prevPage.link;
            }
          }} className="polymer-breadcrumb__title polymer-breadcrumb__title-green">
            {prevPage.title}
          </div>
        ) : (
          <button
            className="polymer-breadcrumb__title polymer-breadcrumb__title-green"
            onClick={() => {
              navigate(-1);
            }}
          >
            {prevPage.title}
          </button>
        )}
      </div>
    );

    // Desktop view
  } else {
    return (
      <div className="polymer-breadcrumb__container" style={style}>
        {pages.map((page, index) => {
          const isLastItem = index === length - 1;
          const reverseIndex = index - length + 1; // Index for the "navigate" function from useNavigate e.g., navigate(-1) will navigate 1 page back
          const isHidden = index !== 0 && index !== length - 1 && index !== length - 2; // When the number of pages > 4, pages other than the first and last 2 pages will be hidden

          if (length > 4 && index === 1) {
            return (
              <>
                <span className="polymer-breadcrumb__title-green" style={{ cursor: "default" }}>
                  ...
                </span>
                <RightArrow key={page.title} />
              </>
            );
          } else if (length > 4 && isHidden) {
            return null;
          } else {
            return <P2BreadcrumbItem key={page.title} isLastItem={isLastItem} navigate={navigate} page={page} reverseIndex={reverseIndex} />;
          }
        })}
      </div>
    );
  }
}

P2Breadcrumb.propTypes = {
  style: PropTypes.object, // Inline style object
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string,
      action: PropTypes.func
    })
  ),
  navigate: PropTypes.func,
};

export default P2Breadcrumb;
